/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Fragment } from 'react';
import { connectStateResults } from 'react-instantsearch-dom';

interface IfHitsProps {
  children: any;
  condition: ({ searchResults }: any) => boolean;
  searchResults: any;
  searchTerm?: string;
}

const IfHits = connectStateResults(
  ({
    children,
    condition = ({ searchResults }: any) =>
      searchResults && searchResults.nbHits > 0,
    searchResults,
    ...props
  }: IfHitsProps) =>
    !searchResults ? (
      <></>
    ) : condition({ ...props, searchResults }) ? (
      children
    ) : (
      <Fragment />
    )
);

export default IfHits;
